export const colors = {
  danger: {
    main: '#E50000',
    onmain: '#FCEDED',
    onsoft: '#5C1210',
    onsofter: '#831B16',
    onstrong: '#FCEDED',
    onstronger: '#FCEDED',
    soft: '#EFACA9',
    softer: '#FAE2E1',
    strong: '#991F1A',
    stronger: '#6D1612',
  },
  info: {
    main: '#2A71DA',
    onmain: '#EDF3FC',
    onsoft: '#13376D',
    onsofter: '#1B4D98',
    onstrong: '#EDF3FC',
    onstronger: '#EDF3FC',
    soft: '#ADC8F0',
    softer: '#E1EAFA',
    strong: '#1F58AD',
    stronger: '#174282',
  },
  neutral: {
    alwaysblack: '#000000',
    alwayswhite: '#FFFFFF',
    main: '#666666',
    onmain: '#F7F7F7',
    onsoft: '#212121',
    onsofter: '#383838',
    onstrong: '#F7F7F7',
    onstronger: '#F7F7F7',
    soft: '#CCCCCC',
    softer: '#F0F0F0',
    strong: '#424242',
    stronger: '#2E2E2E',
  },
  primary: {
    main: '#0A4BF5',
    onmain: '#F0F4FF',
    onsoft: '#04216C',
    onsofter: '#06309D',
    onstrong: '#F0F4FF',
    onstronger: '#F0F4FF',
    soft: '#9DB8FB',
    softer: '#E2EAFE',
    strong: '#0737B0',
    stronger: '#05277F',
  },
  secondary: {
    main: '#E50000',
    onmain: '#FFF0F0',
    onsoft: '#5C0000',
    onsofter: '#8F0000',
    onstrong: '#FFF0F0',
    onstronger: '#FFF0F0',
    soft: '#FF9999',
    softer: '#FFE0E0',
    strong: '#AD0000',
    stronger: '#700000',
  },
  state: {
    disabled: {
      borderneutral: '#CCCCCC',
      ghost: '#FCFCFD',
      neutral: '#CCCCCC',
      onghost: '#666666',
      onneutral: '#666666',
      onsoft: '#F0F0F0',
      onsolid: '#F0F0F0',
      soft: '#CCCCCC',
      solid: '#CCCCCC',
    },
    enabled: {
      borderneutral: '#F0F0F0',
      ghost: '#FCFCFD',
      neutral: '#666666',
      onghost: '#0A4BF5',
      onneutral: '#F7F7F7',
      onsoft: '#0A4BF5',
      onsolid: '#F0F4FF',
      soft: '#E2EAFE',
      solid: '#0A4BF5',
    },
    focus: {
      borderneutral: '#CCCCCC',
      ghost: '#E2EAFE',
      neutral: '#424242',
      onghost: '#0A4BF5',
      onneutral: '#F7F7F7',
      onsoft: '#05277F',
      onsolid: '#F0F4FF',
      soft: '#9DB8FB',
      solid: '#0737B0',
    },
    hover: {
      borderneutral: '#CCCCCC',
      ghost: '#E2EAFE',
      neutral: '#424242',
      onghost: '#0A4BF5',
      onneutral: '#F7F7F7',
      onsoft: '#05277F',
      onsolid: '#F0F4FF',
      soft: '#9DB8FB',
      solid: '#0737B0',
    },
  },
  success: {
    main: '#45A159',
    onmain: '#EDF7F1',
    onsoft: '#214B29',
    onsofter: '#275D33',
    onstrong: '#EDF7F1',
    onstronger: '#EDF7F1',
    soft: '#B7E1C0',
    softer: '#E6F4E9',
    strong: '#378147',
    stronger: '#275D33',
  },
  surface: {
    colorless: '#FCFCFD',
    default: '#FFFFFF',
    high: '#F0F4FF',
    highest: '#05277F',
    low: '#F0F0F0',
    lowest: '#F7F7F7',
    opaque: '#090A0B',
    opaqueinverse: '#FCFCFD',
  },
  warning: {
    main: '#C8AA23',
    onmain: '#FAF7E5',
    onsoft: '#41370B',
    onsofter: '#6C5C13',
    onstrong: '#FAF7E5',
    onstronger: '#FAF7E5',
    soft: '#E5CD67',
    softer: '#F5EECB',
    strong: '#826E17',
    stronger: '#57490F',
  },
} as const
